module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular-Italic.95f6d875.eot";